module.exports = __webpack_public_path__ + "static/media/sl.1a96e936.svg";